import { AxiosError } from 'axios';
import errorsInterceptor from '@/utils/errorsInterceptor';
import { snackbarType } from '@/types/common';

type colorTypes = 'positive' | 'negative' | 'warning' | 'info' | 'ongoing';

export default function (error: any): string[] {
  if (!error.response?.data) {
    return ['Произошла ошибка.'];
  }
  if (error.response?.data['message']) {
    return [error.response.data['message']];
  } else if (error.response?.data['detail']) {
    if (Array.isArray(error.response?.data['detail'])) {
      return error.response?.data['detail'].map((el) => el.msg);
    } else {
      return [error.response.data['detail']];
    }
  }
  return ['Произошла ошибка.'];
}

export function showError(error): void {
  const message = errorsInterceptor(error).join(', ');
  const snackbarParams: snackbarType = {
    message: message,
    type: 'negative',
  };
  const evt = new CustomEvent('ShowSnackbar', {
    detail: snackbarParams,
  });
  window.dispatchEvent(evt);
}

export function showMessage(
  message: string,
  type: colorTypes = 'positive'
): void {
  const snackbarParams: snackbarType = {
    message: message,
    type: type,
  };
  const evt = new CustomEvent('ShowSnackbar', {
    detail: snackbarParams,
  });
  window.dispatchEvent(evt);
}
